import React from 'react';

import { Center } from '../../components/common/Center';
import { Stack } from '../../components/common/Stack';
import deactivated from '../../components/lift/deactivated.svg';
import { useTranslation } from '../../I18nProvider';

export function DoorModelNotSupported() {
  const t = useTranslation();
  return (
    <Stack>
      <div>{t.doorModelNotSupported}</div>
      <Center>
        <img src={deactivated} />
      </Center>
    </Stack>
  );
}
